import React from 'react';
import {   InfoBox,   ExerciseBox,   CodeBlock,   InlineCode,   SectionTitle,  Note,  TableContainer,  Highlight,  PatternContainer,  SectionHeading,  SubHeading,  TwoColGrid,  ThreeColGrid,  GridItem,  Divider} from '../../../../components/course/CourseComponents';

const IntroductionContent = () => {
  return (
    <>
      <InfoBox title="Bienvenue dans ce premier cours" color="blue">
        <p className="mb-0">
        Dans ce cours, tu va decrouvrir les concepts fondamentaux de la programmation et apprendre à écrire tes premiers programmes informatiques. Aucune connaissance préalable n'est requise!
        </p>
      </InfoBox>      

      <SectionTitle>Salut ! </SectionTitle>
      <p>
      Si tu es là, c'est que tu t'intéresses à la programmation de jeux vidéo ! Et c'est une super nouvelle, car le jeu vidéo est un monde extraordinaire qui permet de donner vie à tes idées.
      </p>
    
      
      <p>
      🧑‍🦱 Je m'appelle Michael, et je suis développeur de jeux vidéo depuis 30 ans ! Plus qu'un métier, c'est une vraie passion. Le but de cette formation est de te faire découvrir et de te transmettre cette passion.
      Je vais essayer d'être le plus concis possible, éviter un maximum de blabla, aller à l'essentiel, et surtout, produire un résultat visible et concret le plus rapidement possible.
      </p>

      <Note type="tip" title="Ma philosophie :">
        Un minimum de théorie, et un maximum de pratique !
      </Note>
      
      <p>
      Si ça ne tenait qu'à moi, on commencerait directement à coder un petit jeu, mais il va falloir quand même poser quelques bases. C'est le but de ce premier cours. Peut-être le moins passionnant, mais nécessaire pour comprendre la suite.
      </p>

      <Note type="orange" title="Aucun prerequis n'est nécessaire :">
        Pas besoin d'avoir des connaissances en programmation, ni en informatique, ce site est cles en main.
      </Note>

      <p>
      🎯 Pour faciliter l'aprentissager, ce site te permet de coder et d’exécuter ton programme directement, sans rien installer.
      Pas besoin de logiciel, de compilation ou de configuration : tout fonctionne immédiatement, prêt à l’emploi.
      </p>
      
      <p>
      Alors accroche-toi, et je te promets que d'ici peu de temps, tu auras codé ton premier jeu vidéo ! Et surtout, tu auras compris comment coder un jeu vidéo. Car ici, il ne s'agit pas de recopier bêtement un tuto trouvé sur le net. Le but, c'est que tu comprennes la logique qu'il y a derrière les jeux vidéo !
      </p>

      <SectionTitle>Allez, on commence par la base de la base : la programmation, c'est quoi ?</SectionTitle>
      
     
    </>
  );
};

export default IntroductionContent; 